import React, {createContext, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useFormik, FormikProvider} from 'formik';
import {updateShumaStatus} from '../../_common/actions/shumaStatusActions';

type InspectionStatusContext = {
  status: {label: string, value: number}
  onChangeStatus: (e: React.ChangeEvent<HTMLInputElement>) => void
}

interface InspectionStatusProviderProps {
  children: React.ReactNode
  shumaID: number
  shumaStatusTypeName: string
  shumaStatusTypeID: number
}

const InspectionStatusContext = createContext<InspectionStatusContext>({} as InspectionStatusContext);

export function useInspectionStatusContext() {
  return useContext(InspectionStatusContext);
}

export function InspectionStatusProvider({children, shumaID, shumaStatusTypeName, shumaStatusTypeID}: InspectionStatusProviderProps) {
  const getInitialValues = () => {
    formik.setFieldValue('status', {label: shumaStatusTypeName, value: shumaStatusTypeID})
  };

  useEffect(() => {
    getInitialValues();
  }, [shumaStatusTypeID]);

  const formik = useFormik({
    initialValues: {status: {label: '', value: 0}},
    onSubmit: () => {
    },
  });

  const onChangeStatus = (option: any) => {
    formik.setFieldValue('status', {label: option.label, value: option.value});
  };

  const onSubmit = async () => {
    await updateShumaStatus(shumaID, formik.values.status.value);
  }

  const value = {
    status: formik.values.status,
    onChangeStatus,
    onSubmit
  };

  return (
    <InspectionStatusContext.Provider value={value}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </InspectionStatusContext.Provider>
  );
}

InspectionStatusProvider.propTypes = {
  children: PropTypes.node,
};
